import { connect, ConnectedProps } from 'react-redux'

import {
  setAccordionExpandedNodeTitle,
  setAccordionExpandedNodeId,
  updateExpandedNodeIdState,
  setAccordionState,
  pageToggleRight,
  setAccordionGroup,
  handleExpandedTitleOnClick,
  setAccordionBreadCrumbClicked,
  setAccordionUrlNode
} from 'redux/actions'
import AccordionWrapper from 'components/accordion'
import { AppDispatch, RootState } from 'redux/store'
import { AccordionState } from 'redux/reducers/accordion'
import { ExpandCallback, AccordionGroup } from 'interfaces/accordion'


const mapStateToProps = (state: RootState) => ({
  flavour: state.layout.flavour,
  isMouseAbilityOpen: state.page.isMouseAbilityOpen,
  aol: state.aol.name
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  pageToggleRight: (force: boolean) => dispatch(pageToggleRight(force) as any),// FIX ME remove as any
  setAccordionExpandedNodeId: (expandedNodeId: string) => dispatch(setAccordionExpandedNodeId(expandedNodeId)),
  setAccordionExpandedNodeTitle: (expandedNodeTitle: string) => dispatch(setAccordionExpandedNodeTitle(expandedNodeTitle)),
  updateExpandedNodeIdState: (id: string, value: string) => dispatch(updateExpandedNodeIdState(id, value) as any), // FIX ME remove as any
  setAccordionGroup: (group: AccordionGroup[]) => dispatch(setAccordionGroup(group)),
  setAccordionState: (props: Partial<AccordionState> & ExpandCallback) => dispatch(setAccordionState(props) as any),// FIX ME remove as any
  handleExpandedTitleOnClick: () => dispatch(handleExpandedTitleOnClick() as any),// FIX ME remove as any
  setAccordionBreadCrumbClicked: (breadCrumbClicked: boolean) => dispatch(setAccordionBreadCrumbClicked(breadCrumbClicked)),
  setAccordionUrlNode: (urlNode: string) => dispatch(setAccordionUrlNode(urlNode))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type AccordionWrapperContainerProps = ConnectedProps<typeof connector>

export default connector(AccordionWrapper)
